import styled from 'styled-components';

export const SideDropWrapper = styled.div`
  position: absolute;
  background-color: ${(props) => props.theme.bg.mainGreen};
  right: 44px;
  top: 0;
  width: 306px;
  //max-height: 500px;
  color: white;
  padding: 13px 20px;
  z-index: 999;
  border-radius: 10px 0 10px 10px;
  //height: 444px;
  h3 {
    margin: 0 0 15px;
  }
`;

export const DropContent = styled.div`
  display: flex;
  flex-direction: column;
    height: 100%;
    overflow: auto;
`;

// SideDropWrapper
// SideDropTitle

export const SideDropTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
`;

